/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exitedbusinessview2Inputs */

const en_exitedbusinessview2 = /** @type {(inputs: Exitedbusinessview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exited business view`)
};

const de_exitedbusinessview2 = /** @type {(inputs: Exitedbusinessview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensansicht verlassen`)
};

/**
* | output |
* | --- |
* | "Exited business view" |
*
* @param {Exitedbusinessview2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const exitedbusinessview2 = /** @type {((inputs?: Exitedbusinessview2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exitedbusinessview2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exitedbusinessview2(inputs)
	return de_exitedbusinessview2(inputs)
});
export { exitedbusinessview2 as "exitedBusinessView" }